import React from 'react';
import MemberManagement from './MemberManagement';
import { useRootState } from '../../useRoot';

const Index = () => {
  const { isAdmin } = useRootState();

  if (!isAdmin) {
    return <p>僅限管理者</p>;
  }

  return <MemberManagement />;
};

export default Index;
